export default __webpack_public_path__ + "static/media/logo_big.672a1da0.png";